import { render, staticRenderFns } from "./RequiredDocuments.vue?vue&type=template&id=0e4bdae0&scoped=true"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js"
import style0 from "./RequiredDocuments.vue?vue&type=style&index=0&id=0e4bdae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4bdae0",
  null
  
)

export default component.exports